<template>
  <div id="app">
    <div class="config">
      <div class="representation">
        <div class="img-prev">
          <drawer
            :unit="unitShort"
            :diameter="selectedDiameter"
            :insertionLength="data[selectedUnit].insertLength"
            :voltage="data.config.voltage"
            :wattage="data.config.wattage"
            :potting="selectedEndSeal"
            :leadProtection="selectedExitLeadProtection"
            :NPTProcessFitting="selectedProcessCoonnection"
            :NPTFitting="selectedProcessFitting"
            :fittingOption="selectedNPTFitting"
            :leadInsulationMat="selectedLeadMaterial"
            :leadLength="data[selectedUnit].leadLength"
            :protectionLength="data[selectedUnit].protectionLength"
            :internalThermoCouple="selectedInternalThermoCouple"
            :thermoCoupleLocation="selectedThermoCoupleLocation"
            :groundWire="selectedGroundWire"
            :fiberGlassSleving="selectedFibreGlassSleeving"
            :endSeal="selectedEndSeal"
          />
          <div style="display: flex; justify-content: center; width: 100%">
            <!-- {{ reference }} -->
          </div>
        </div>
        <vs-button
          color="primary"
          type="filled"
          icon="arrow_back_ios"
          class="next-btn"
          v-if="showForm === true"
          @click="showForm = false"
          >Back</vs-button
        >

        <vs-button
          color="primary"
          type="filled"
          icon="arrow_back_ios"
          class="back-btn-msg"
          v-if="sumbitSuceess"
          @click="
            () => {
              showForm = false;
              sumbitSuceess = false;
            }
          "
          >Back</vs-button
        >

        <vs-button
          color="primary"
          type="filled"
          icon="arrow_forward_ios"
          class="next-btn"
          icon-after
          v-if="!sumbitSuceess && !showForm"
          @click="showForm = true"
          >Next</vs-button
        >
      </div>

      <div class="configuration" ref="" v-if="!showForm && !sumbitSuceess">
        <vs-row style="padding: 0 0.75rem">
          <vs-col
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-lg="6"
            vs-xs="12"
            style="padding: 0 0.25rem"
          >
            <vs-select
              label="Units"
              placeholder="Select"
              v-model="selectedUnit"
              width="100%"
            >
              <vs-select-item
                v-for="(unit, index) in units"
                :key="index"
                :text="unit.label"
                :value="unit.id"
                @change="updateDiameterList"
              />
            </vs-select>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-lg="6"
            vs-xs="12"
            style="padding: 0 0.25rem"
          >
            <vs-select
              :label="`Diameter (${unitShort}) *`"
              placeholder="Select"
              v-model="selectedDiameter"
              width="100%"
            >
              <vs-select-item
                v-for="(unit, index) in data[selectedUnit].diameter"
                :key="index"
                :text="unit.label"
                :value="unit.id"
              />
            </vs-select>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-lg="6"
            vs-xs="12"
            style="padding: 0 0.25rem"
          >
            <vs-input
              type="text"
              label="Insert Length*"
              icon-after
              v-model="data[selectedUnit].insertLength"
              style="width: 100%"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-lg="6"
            vs-xs="12"
            style="padding: 0 0.25rem"
          >
            <vs-input
              type="text"
              label="Voltage*"
              v-model="data.config.voltage"
              icon="V"
              icon-after="true"
              style="width: 100%"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-lg="12"
            vs-xs="12"
            style="padding: 0 0.25rem"
          >
            <vs-input
              type="text"
              label="Wattage*"
              v-model="data.config.wattage"
              icon="W"
              icon-after="true"
              style="width: 100%"
            />
          </vs-col>
        </vs-row>
        <vs-divider></vs-divider>
        <vs-row>
          <vs-col
            vs-xs="12"
            vs-sm="12"
            col
            vs-lg="12"
            style="border-right: 1px solid #8080804a"
          >
            <vs-row style="padding: 0.5rem">
              <vs-col vs-w="12">
                <vs-select
                  label="NPT Fitting / Flange"
                  placeholder="Select"
                  v-model="selectedProcessCoonnection"
                  width="100%"
                >
                  <vs-select-item
                    v-for="(unit, index) in data.config.processConnection"
                    :key="index"
                    :text="unit.label"
                    :value="unit.id"
                  />
                </vs-select>
              </vs-col>
            </vs-row>
            <vs-row v-if="processConnectionOptions" style="padding: 0.5rem">
              <vs-col vs-w="12">
                <p>Fitting Options</p>
                <div class="options-wrapper">
                  <div
                    class="option"
                    :class="{ active: op == selectedNPTFitting }"
                    v-for="op in processConnectionOptions"
                    :key="op.id"
                    @click="setActiveNPTPFitting(op)"
                  >
                    <div class="icon">
                      <i
                        class="material-icons"
                        style="font-size: 20px; color: #8c0000"
                        >check_circle</i
                      >
                    </div>
                    <div
                      class="img"
                      :style="{ backgroundImage: `url(${op.img})` }"
                    ></div>
                    <div class="text">
                      <span>{{ op.label }}</span>
                    </div>
                  </div>
                </div>
              </vs-col>
              <vs-col vs-w="12">
                <vs-select
                  label="Process Fitting / Connection"
                  placeholder="Select"
                  v-model="selectedProcessFitting"
                  style="width: 100%; margin-top: 0.5rem"
                >
                  <vs-select-item
                    v-for="(unit, index) in processFittingOptions"
                    :key="index"
                    :text="unit.label"
                    :value="unit.id"
                  />
                </vs-select>
              </vs-col>
            </vs-row>

            <vs-row
              v-if="selectedProcessCoonnection == 'Flange'"
              style="padding: 0.5rem"
            >
              <vs-col>
                <label style="upload-file" for="Flange---Picture">
                  Upload Drawing or Picture of Flange</label
                >
                <br />
                <input
                  type="file"
                  name="Flange---Pictures"
                  id="Flange---Picture"
                  @change="setFlangePicture($event)"
                  accept="image/png, image/jpeg"
                />
              </vs-col>
            </vs-row>
          </vs-col>

          <vs-col
            vs-xs="12"
            vs-sm="12"
            col
            vs-lg="12"
            style="border-right: 1px solid #8080804a"
          >
            <vs-row style="padding: 0.2rem">
              <vs-col vs-w="12">
                <p>Exit & Lead Protection</p>
                <div class="options-wrapper">
                  <div
                    class="option"
                    :class="{ active: op.id == selectedExitLeadProtection.id }"
                    v-for="op in data.config.exitLeadProtection"
                    :key="op.id"
                    :id="op.id"
                    @click="setActiveExitLeadProtection(op)"
                  >
                    <div class="icon">
                      <i
                        class="material-icons"
                        style="font-size: 20px; color: #8c0000"
                        >check_circle</i
                      >
                    </div>
                    <div
                      class="img"
                      :style="{ backgroundImage: `url(${op.img})` }"
                    ></div>
                    <div class="text">
                      <span>{{ op.label }}</span>
                    </div>
                  </div>
                </div>
              </vs-col>
            </vs-row>
            <vs-row vs-w="12">
              <vs-col vs-w="12" style="padding: 0.5rem">
                <vs-select
                  label="Lead Material"
                  placeholder="Select"
                  v-model="selectedLeadMaterial"
                  :width="'100%'"
                >
                  <vs-select-item
                    v-for="(unit, index) in data.config.leadMaterial"
                    :key="index"
                    :text="unit.label"
                    :value="unit.id"
                  />
                </vs-select>

                <vs-input
                  type="text"
                  label="Lead Length"
                  placeholder="Specify Inches or mm"
                  v-model="data[selectedUnit].leadLength"
                  icon-after="true"
                  style="width: 100%; margin-top: 0.5rem"
                />
                <vs-input
                  type="text"
                  label="Protection Length"
                  placeholder="Specify Inches or mm"
                  v-model="data[selectedUnit].protectionLength"
                  icon-after="true"
                  style="width: 100%; margin-top: 0.5rem"
                />
              </vs-col>
            </vs-row>
          </vs-col>

          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <vs-row style="padding: 0.5rem">
              <vs-col vs-w="12">
                <vs-select
                  label="Internal Thermocouple"
                  placeholder="Select"
                  v-model="selectedInternalThermoCouple"
                  width="100%"
                >
                  <vs-select-item
                    v-for="(unit, index) in data.config.internalThermoCouple"
                    :key="index"
                    :text="unit.label"
                    :value="unit.id"
                  />
                </vs-select>
              </vs-col>
            </vs-row>
            <vs-row style="padding: 0.5rem">
              <vs-col vs-w="12" v-if="internalThermoCoupleOptions">
                <p>Thermocouple Location</p>
                <div class="options-wrapper">
                  <div
                    class="option"
                    v-for="op in internalThermoCoupleOptions"
                    :key="op.id"
                    :class="{
                      active: op.id == selectedThermoCoupleLocation.id,
                    }"
                    @click="setActiveTermoCoupleLocation(op)"
                  >
                    <div class="icon">
                      <i
                        class="material-icons"
                        style="font-size: 20px; color: #8c0000"
                        >check_circle</i
                      >
                    </div>
                    <div
                      class="img"
                      :style="{ backgroundImage: `url(${op.img})` }"
                    ></div>
                    <div class="text">
                      <span>{{ op.label }}</span>
                    </div>
                  </div>
                </div>
              </vs-col>
              <vs-col vs-w="12">
                <vs-select
                  label="Ground Wire"
                  placeholder="Select"
                  v-model="selectedGroundWire"
                  style="width: 100%; margin-top: 0rem"
                >
                  <vs-select-item
                    v-for="(unit, index) in this.data.config.groundWire"
                    :key="index"
                    :text="unit.label"
                    :value="unit.id"
                  />
                </vs-select>
              </vs-col>
              <vs-col vs-w="12">
                <vs-select
                  label="Fiberglass Sleeving"
                  placeholder="Select"
                  v-model="selectedFibreGlassSleeving"
                  style="width: 100%; margin-top: 0.5rem"
                >
                  <vs-select-item
                    v-for="(unit, index) in this.data.config.fibreGlassSleeving"
                    :key="index"
                    :text="unit.label"
                    :value="unit.id"
                  />
                </vs-select>
              </vs-col>
              <vs-col vs-w="12">
                <vs-select
                  label="End Seal / Potting"
                  placeholder="Select"
                  v-model="selectedEndSeal"
                  style="width: 100%; margin-top: 0.5rem"
                >
                  <vs-select-item
                    v-for="(unit, index) in this.data.config.endSeal"
                    :key="index"
                    :text="unit.label"
                    :value="unit.id"
                  />
                </vs-select>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
      <div class="contact-form" v-if="showForm">
        <vs-row>
          <vs-col>
            <vs-divider></vs-divider>

            <form action="#">
              <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12"> </vs-col>
                <vs-row class="grid" vs-w="12">
                  <vs-select
                    label="Quantity Required *"
                    placeholder="Select"
                    v-model="selectedQty"
                    width="100%"
                    style="margin-bottom: 0.5rem; padding: 0.5rem"
                  >
                    <vs-select-item
                      v-for="(unit, index) in quantities"
                      :key="index"
                      :text="unit.label"
                      :value="unit.id"
                    />
                  </vs-select>
                  <vs-select
                    label="Required Lead Time *"
                    placeholder="Select"
                    v-model="selectedLeadTime"
                    width="100%"
                    style="margin-bottom: 0.5rem; padding: 0.5rem"
                    multiple
                  >
                    <vs-select-item
                      v-for="(unit, index) in leadTimes"
                      :key="index"
                      :text="unit.label"
                      :value="unit.label"
                    />
                  </vs-select>

                  <vs-input
                    type="email"
                    label="Email *"
                    placeholder="Email "
                    v-model="formEmail"
                    icon-after="true"
                    style="width: 100%; margin-bottom: 0.5rem; padding: 0.5rem"
                  />
                  <vs-input
                    type="phone"
                    label="Phone *"
                    placeholder="Phone "
                    v-model="formPhone"
                    icon-after="true"
                    style="width: 100%; margin-bottom: 0.5rem; padding: 0.5rem"
                  />
                  <vs-textarea label="Message" v-model="formMsg" />
                  <vs-row style="margin-bottom: 1rem">
                    <vs-col>
                      <input
                        type="file"
                        name="Form--Pictures"
                        id="Form-Picture"
                        @change="setFormPicture($event)"
                        accept="image/png, image/jpeg"
                      />
                    </vs-col>
                  </vs-row>
                </vs-row>
                <vs-col vs-w="2"></vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-w="4"></vs-col>
                <vs-col vs-w="4" vs-type="flex" vs-justify="center">
                  <vs-button
                    color="primary"
                    type="filled"
                    icon="arrow_forward_ios"
                    class="submit-btn"
                    icon-after
                    @click="submitForm"
                    >SUBMIT</vs-button
                  >
                </vs-col>
                <vs-col vs-w="4"></vs-col>
              </vs-row>
            </form>

            <vs-divider></vs-divider>
          </vs-col>
        </vs-row>
      </div>
      <div class="success-submit-msg" v-if="sumbitSuceess">
        <vs-row>
          <vs-col vs-w="4" style="position: relative"> </vs-col>
          <vs-col
            vs-w="4"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 40vh;
            "
          >
            <h3>
              Thank you for your inquiry. A sales engineer will be in touch as
              soon as possible!
            </h3>
          </vs-col>
          <vs-col vs-w="4"></vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import drawer from "./drawer-v2.vue";
import * as htmlToImage from "html-to-image";

export default {
  name: "App",
  components: { drawer },
  methods: {
    initMesurements() {
      this.data.metric.leadLength = "";
      this.data.metric.protectionLength = "";
      this.data.metric.insertLength = "";
      this.data.imperial.leadLength = "";
      this.data.imperial.protectionLength = "";
      this.data.imperial.insertLength = "";
      this.selectedDiameter = "";
    },
    submitForm() {
      var that = this;
      if (
        that.formEmail &&
        that.formPhone &&
        that.quantities &&
        that.leadTimes &&
        that.selectedDiameter
      ) {
        try {
          const capture = document.querySelector("#drawer");
          htmlToImage
            .toPng(capture)
            .then(async function (dataUrl) {
              var flangePictureBase64, formPictureBase64;

              if (that.flangePicture) {
                flangePictureBase64 = await that.fileToBase64(
                  that.flangePicture
                );
              } else {
                flangePictureBase64 = null;
              }
              if (that.formPicture) {
                formPictureBase64 = await that.fileToBase64(that.formPicture);
              } else {
                formPictureBase64 = null;
              }
              //https://reno-mailer.herokuapp.com
              axios
                .post("https://reno-mailer.herokuapp.com/heaters-mailer", {
                  // ref: that.reference,
                  qty: that.selectedQty,
                  leadTime: that.selectedLeadTime,
                  formEmail: that.formEmail,
                  formPhone: that.formPhone,
                  formMsg: that.formMsg,
                  img: dataUrl,
                  flangePicture: flangePictureBase64,
                  formPicture: formPictureBase64,
                })
                .then((res) => {
                  if (res.status == 200) {
                    that.selectedQty = "";
                    that.selectedLeadTime = [];
                    that.formEmail = "";
                    that.formPhone = "";
                    that.formMsg = "";
                    that.showForm = false;

                    that.sumbitSuceess = true;
                  }
                });
            })
            .catch(function (error) {
              console.error("oops, something went wrong!", error);
            });
        } catch (error) {
          alert(error);
        }
      } else {
        alert("Please Fill all the required(*) fields!");
      }
    },
    setActiveNPTPFitting(op) {
      this.selectedNPTFitting = op;
    },

    setActiveExitLeadProtection(op) {
      this.selectedExitLeadProtection = op;
    },
    setActiveTermoCoupleLocation(op) {
      this.selectedThermoCoupleLocation = op;
    },
    updateDiameterList() {
      this.selectedDiameter = null;
    },
    // Convert file to base64 string
    fileToBase64(file) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        // Read file content on file loaded event
        reader.onload = function (event) {
          resolve(event.target.result);
        };

        // Convert data to base64
        reader.readAsDataURL(file);
      });
    },
    setFlangePicture(e) {
      this.flangePicture = e.target.files[0];
    },
    setFormPicture(e) {
      this.formPicture = e.target.files[0];
    },
  },
  computed: {
    reference() {
      return (
        "C" +
        this.unitRef +
        this.leadExitProtectionRef +
        this.diameterRef +
        "-" +
        this.insertLength +
        "-" +
        this.voltageRef +
        "-" +
        this.wattageRef +
        "-" +
        this.internalThermoCoupleOptionRef +
        "-" +
        this.processConnectionOptionRef

        //  X-S-G-E"
      );
    },
    unitShort() {
      return this.selectedUnit == "metric" ? "mm" : "inches";
    },
    processConnectionOptions() {
      let cnxs = this.data.config.processConnection.filter(
        (op) => op.id == this.selectedProcessCoonnection
      )[0];
      if (cnxs) {
        return cnxs.options ? cnxs.options : null;
      } else {
        return false;
      }
    },
    processFittingOptions() {
      let cnxs = this.data.config.processConnection.filter(
        (op) => op.id == this.selectedProcessCoonnection
      )[0];
      console.log(cnxs);
      if (cnxs) {
        return cnxs.fittings ? cnxs.fittings : null;
      } else {
        return false;
      }
    },
    internalThermoCoupleOptions() {
      let cnxs = this.data.config.internalThermoCouple.filter(
        (op) => op.id == this.selectedInternalThermoCouple
      )[0];
      if (cnxs) {
        return cnxs.options ? cnxs.options : null;
      } else {
        return false;
      }
    },
    unitRef() {
      return this.units.filter((unit) => unit.id == this.selectedUnit)[0].ref;
    },
    diameterRef() {
      if (this.selectedDiameter) {
        let dim = this.data[this.selectedUnit].diameter.filter(
          (d) => d.id == this.selectedDiameter
        );

        return dim[0] ? dim[0].ref : "X";
      } else {
        return "X";
      }
    },
    insertLength() {
      return this.data[this.selectedUnit].insertLength.length > 0
        ? this.data[this.selectedUnit].insertLength
        : 0;
    },
    voltageRef() {
      return this.data.config.voltage.length > 0 ? this.data.config.voltage : 0;
    },
    wattageRef() {
      return this.data.config.wattage.length > 0
        ? this.data.config.wattage
        : "R";
    },
    leadExitProtectionRef() {
      let ref = this.selectedExitLeadProtection;
      return ref ? ref.ref : "M";
    },
    internalThermoCoupleOptionRef() {
      let IT, IT_POS;
      IT = this.data.config.internalThermoCouple.filter(
        (d) => d.id == this.selectedInternalThermoCouple
      )[0];

      IT_POS = this.selectedThermoCoupleLocation;
      let res = `${IT ? IT.ref : "X"}${IT_POS.ref ? IT_POS.ref : "X"}`;
      return res;
    },
    processConnectionOptionRef() {
      let IT, IT_POS, PTF;
      IT = this.data.config.processConnection.filter(
        (d) => d.id == this.selectedProcessCoonnection
      )[0];

      if (this.processFittingOptions) {
        PTF = this.processFittingOptions.filter(
          (d) => d.id == this.selectedProcessFitting
        )[0];
      } else {
        PTF = null;
      }
      console.log(IT);
      IT_POS = this.selectedNPTFitting;
      let res = `${IT ? IT.ref : "X"}
      ${IT ? (IT.ref !== "X" ? (IT_POS.ref ? IT_POS.ref : "X") : "X") : "X"}
      ${IT ? (IT.ref !== "X" ? (PTF ? PTF.ref : "X") : "X") : "X"}`;
      return res;
    },
  },
  watch: {
    selectedUnit() {
      this.initMesurements();
    },
  },
  data() {
    return {
      //flange pic
      flangePicture: null,
      formPicture: null,
      //form
      showForm: false,
      sumbitSuceess: false,
      //selections
      selectedUnit: "metric",
      selectedDiameter: "",
      selectedProcessCoonnection: "",
      selectedProcessFitting: "",
      selectedLeadMaterial: "MGT - 842°F / 450°C",
      selectedExitLeadProtection: {
        id: "Straight / None",
        label: "Straight / None",
        img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/straight-leads.jpg",
        ref: "A",
      },
      selectedInternalThermoCouple: "None",

      selectedGroundWire: "",
      selectedFibreGlassSleeving: "",
      selectedEndSeal: "Cement Potting (Standard) - 1800°F 982°C",

      //sub options selections
      selectedNPTFitting: {},
      selectedThermoCoupleLocation: {
        id: "Disk End",
        label: "Disk End",
        img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/disk-temp.jpg",
        ref: "E",
      },

      //Data
      units: [
        { id: "imperial", short: "mm", label: "Imperial (inches)", ref: "S" },
        { id: "metric", short: "inches", label: "Metric (mm)", ref: "M" },
      ],
      data: {
        metric: {
          diameter: [
            { id: "", label: "", ref: "0" },
            { id: "6mm", label: "6mm", ref: "6" },
            { id: "6.5mm", label: "6.5mm", ref: "7" },
            { id: "8mm", label: "8mm", ref: "8" },
            { id: "10mm", label: "10mm", ref: "10" },
            { id: "12mm", label: "12mm", ref: "12" },
            { id: "12.5mm", label: "12.5mm", ref: "13" },
            { id: "13mm", label: "13mm", ref: "13" },
            { id: "14mm", label: "14mm", ref: "14" },
            { id: "15mm", label: "15mm", ref: "15" },
            { id: "16mm", label: "16mm", ref: "16" },
            { id: "17mm", label: "17mm", ref: "17" },
            { id: "19mm", label: "19mm", ref: "19" },
            { id: "20mm", label: "20mm", ref: "20" },
            { id: "21mm", label: "21mm", ref: "21" },
            { id: "25mm", label: "25mm", ref: "25" },
          ],
          insertLength: "",
          leadLength: "",
          protectionLength: "",
        },
        imperial: {
          diameter: [
            { id: "", label: "" },
            { id: '1/8"', label: '1/8"' },
            { id: '1/4"', label: '1/4"' },
            { id: '5/16"', label: '5/16"' },
            { id: '3/8"', label: '3/8"' },
            { id: '1/2"', label: '1/2"' },
            { id: '17/32"', label: '17/32"' },
            { id: '5/8"', label: '5/8"' },
            { id: '11/16"', label: '11/16"' },
            { id: '3/4"', label: '3/4"' },
            { id: '7/8"', label: '7/8"' },
            { id: '1"', label: '1"' },
          ],
          insertLength: "",
          leadLength: "",
          protectionLength: "",
        },
        config: {
          voltage: "",
          wattage: "",
          exitLeadProtection: [
            {
              id: "Straight / None",
              label: "Straight / None",
              img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/straight-leads.jpg",
              ref: "A",
            },
            {
              id: "90° / None",
              label: "90° / None",
              img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/90-leads.jpg",
              ref: "B",
            },
            {
              id: "Straight / SS Braid",
              label: "Straight / SS Braid",
              img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/straight-braid.jpg",
              ref: "C",
            },
            {
              id: "90° / SS Braid",
              label: "90° / SS Braid",
              img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/90-braid.jpg",
              ref: "D",
            },
            {
              id: "Straight / SS Armor",
              label: "Straight / SS Armor",
              img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/straight-armor.jpg",
              ref: "E",
            },
            {
              id: "90° / SS Armor",
              label: "90° / SS Armor",
              img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/90-armor.jpg",
              ref: "F",
            },
          ],
          leadMaterial: [
            {
              id: "MGT 1000°C - 1832°F / 1000°C",
              label: "MGT 1000°C - 1832°F / 1000°C",
            },
            {
              id: "MGT 750°C - 1382°F / 750°C",
              label: "MGT 750°C - 1382°F / 750°C",
            },
            {
              id: "Duraflex - 1022°F / 550°C",
              label: "Duraflex - 1022°F / 550°C",
            },
            { id: "MGT - 842°F / 450°C", label: "MGT - 842°F / 450°C" },
            { id: "TGGT - 482°F / 250°C", label: "TGGT - 482°F / 250°C" },
            {
              id: "Teflon - 500°F / 260°C",
              label: "Teflon - 500°F / 260°C",
            },
            {
              id: "Silicone - 355°F / 180°C",
              label: "Silicone - 355°F / 180°C",
            },
          ],

          processConnection: [
            { id: "None", label: "None", ref: "X" },
            {
              id: "NPT-Process-Fitting",
              label: "NPT Process Fitting",
              ref: "NPT",
              fittings: [
                { id: '1/8"NPT', label: '1/8"NPT', ref: "A" },
                { id: '1/4"NPT', label: '1/4"NPT', ref: "B" },
                { id: '3/8"NPT', label: '3/8"NPT', ref: "C" },
                { id: '1/2"NPT', label: '1/2"NPT', ref: "D" },
                { id: '3/4"NPT', label: '3/4"NPT', ref: "E" },
                { id: '1"NPT', label: '1"NPT', ref: "F" },
              ],

              options: [
                {
                  id: "Stainless",
                  label: "Stainless",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/stainless-fitting.jpg",
                  ref: "SS",
                },
                {
                  id: "Brass",
                  label: "Brass",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/brass-fitting.jpg",
                  ref: "BR",
                },
                {
                  id: "Double Ended (Brass Only)",
                  label: "Double Ended (Brass Only)",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/double-ended-fitting.jpg",
                  ref: "DE",
                },
              ],
            },
            {
              id: "Flange",
              label: "Flange",
              ref: "FP",
            },
          ],
          internalThermoCouple: [
            { id: "None", label: "None", ref: "X" },
            {
              id: "Type J",
              label: "Type J",
              ref: "J",
              options: [
                {
                  id: "Disk End",
                  label: "Disk End",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/disk-temp.jpg",
                  ref: "E",
                },
                {
                  id: "Middle (Sheath Temp)",
                  label: "Middle (Sheath Temp)",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/sheath-temp.jpg",
                  ref: "MS",
                },
                {
                  id: "Middle (Heater Temp)",
                  label: "Middle (Heater Temp)",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/heater-temp.jpg",
                  ref: "MT",
                },
              ],
            },
            {
              id: "Type K",
              label: "Type K",
              ref: "K",
              options: [
                {
                  id: "Disk End",
                  label: "Disk End",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/disk-temp.jpg",
                  ref: "E",
                },
                {
                  id: "Middle (Sheath Temp)",
                  label: "Middle (Sheath Temp)",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/sheath-temp.jpg",
                  ref: "MS",
                },
                {
                  id: "Middle (Heater Temp)",
                  label: "Middle (Heater Temp)",
                  img: "https://y7i7t6v2.rocketcdn.me/wp-content/uploads/2022/01/heater-temp.jpg",
                  ref: "MT",
                },
              ],
            },
          ],
          groundWire: [
            { id: "No", label: "No" },
            { id: "Yes", label: "Yes" },
          ],
          fibreGlassSleeving: [
            { id: "No Sleeving", label: "No Sleeving" },
            {
              id: "1 sleeve over both leads",
              label: "1 sleeve over both leads",
            },
            { id: "1 sleeve over each lead", label: "1 sleeve over each lead" },
          ],
          endSeal: [
            {
              id: "Cement Potting (Standard) - 1800°F 982°C",
              label: "Cement Potting (Standard) - 1800°F 982°C",
            },
            {
              id: "Ceramic End Piece - 2500°F 1371°C",
              label: "Ceramic End Piece - 2500°F 1371°C",
            },
            {
              id: "Teflon Seal - 300°F 149°C",
              label: "Teflon Seal - 300°F 149°C",
            },
            {
              id: "Laval End Piece - 3000°F 1649°C",
              label: "Laval End Piece - 3000°F 1649°C",
            },
            {
              id: "Epoxylite Potting - 650°F 343°C",
              label: "Epoxylite Potting - 650°F 343°C",
            },
            {
              id: "Epoxy Potting -265°F 129°C",
              label: "Epoxy Potting -265°F 129°C",
            },
            {
              id: "Silicone Rubber - 500°F 260°C",
              label: "Silicone Rubber - 500°F 260°C",
            },
          ],
          requiredLeadTime: [],
        },
      },

      //form
      formMsg: null,
      formEmail: null,
      formPhone: null,
      selectedQty: null,
      selectedLeadTime: [],
      quantities: [
        { id: "1", label: "1" },
        { id: "2-4", label: "2-4" },
        { id: "5-9", label: "5-9" },
        { id: "10-24", label: "10-24" },
        { id: "25-49", label: "25-49" },
        { id: "50-99", label: "50-99" },
        { id: "100+", label: "100+" },
      ],
      leadTimes: [
        {
          id: "Same Day Manufacturing *Requests are processed immediately",
          label: "Same Day Manufacturing *Requests are processed immediately",
        },
        { id: "1-2 Day Manufacturing", label: " 1-2 Day Manufacturing" },
        { id: "3-5 Day Manufacturing", label: " 3-5 Day Manufacturing" },
        { id: "1 Week Manufacturing", label: " 1 Week Manufacturing" },
        {
          id: "5",
          label: "1.5 Weeks Manufacturing (Standard)",
        },
      ],
    };
  },
};
</script>


<style lang="scss">
.back-btn {
  position: absolute;
  bottom: 1rem;
  left: 1rem;

  min-width: 100px;
  font-weight: bold;
}
.back-btn-form {
  position: absolute;
  top: 1rem;
  left: 1rem;

  min-width: 100px;
  font-weight: bold;
}
.back-btn-msg {
  position: absolute;
  top: 1rem;
  left: 1rem;

  min-width: 100px;
  font-weight: bold;
}
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
@import url("https://cdn.jsdelivr.net/npm/vuesax/dist/vuesax.css");
@import url("https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300;500;600&display=swap");

body {
  font-family: "Hind Siliguri", sans-serif;
  overflow: hidden;
}

#app {
  overflow-x: hidden;
}
:root {
  --vs-primary: 140, 0, 0 !important;
  --vs-danger: 255, 71, 87;
  --vs-success: 70, 201, 58;
  --vs-dark: 30, 30, 30;
  --vs-warning: 255, 186, 0;
  --vs-light: 245, 245, 245;
}

.input-select-label-primary--active {
  color: #8c0000 !important;
}

.success-submit-msg {
  height: 45vh;
  border-top: 1px solid rgb(206, 206, 206);
}
.representation {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100vh;
  .img-prev {
    .img-respo {
      display: block;
      max-width: 100%;
      height: auto;
      max-height: 280px;
      padding: 20px;
    }
  }

  .next-btn {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    min-width: 150px;
    font-weight: bold;
    z-index: 55;
  }
}
.configuration {
  position: relative;
  overflow-y: auto !important;
  height: 100vh;
  width: 50vw;
  border: 1px solid #eee;
  margin-top: 5px;
}

/* .configuration::after {
  content: "";
  position: fixed;
  top: 55vh;
  left: 0;
  width: 100%;
  height: 5px;
  box-shadow: 0px 5px 10px #eee, 0px 0px 0px rgb(255, 255, 255, 0.1);
  background-color: white;
  z-index: 100;
} */

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background-color: #eee;
  -webkit-border-radius: 10px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #777;
}
.contact-form {
  position: relative;
  overflow-y: auto !important;
  height: 100vh;
}

.submit-btn {
  min-width: 250px;
  font-weight: bold;
}
.options-wrapper {
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  // ;
  .option {
    width: 100px;
    height: 120px;
    position: relative;
    border: 1px solid rgba(128, 128, 128, 0.349);
    border-radius: 5px;
    margin: 5px 5px 5px 0;
    &:hover {
      border: 2px solid #8c0000;
    }

    &.active {
      border: 2px solid #8c0000;
      .icon {
        display: block;
      }
    }

    .icon {
      position: absolute;
      width: 20px;
      height: 20px;
      top: -10px;
      left: -10px;
      background-color: white;
      display: none;
      border-radius: 10px;
    }
    .img {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      height: 85px;
      width: 100%;
    }

    .text {
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 12px;
        text-align: center;
      }
    }
  }
}

.config {
  display: flex;
  flex-direction: row-reverse;
}

$background-color: #292931;
$button-color: #8c0000;
$button-width: 10em;

label[for="file-input"] {
  display: block;
  margin-bottom: 1em;
  font-size: 1em;
  color: #fff;
  opacity: 0.9;
  font-weight: bold;
}

input[type="file"] {
  cursor: pointer !important;

  &::-webkit-file-upload-button {
    background: $button-color;
    border: 0;
    padding: 0.7em 2em;
    cursor: pointer;
    color: #fff;
    border-radius: 0.2em;
  }

  &::-ms-browse {
    background: $button-color;
    border: 0;
    padding: 0.7em 2em;
    cursor: pointer;
    color: #fff;
    border-radius: 0.2em;
  }
}

@media screen and (max-width: 990px) {
  // .options-wrapper {
  //   .option {
  //     width: 60px !important;
  //     height: 80px !important;
  //   }
  // }
}

@media screen and (max-width: 990px) {
  #drawer-v2 {
    height: 350px !important;
  }
}
</style>
